<template>
    <div class="container-fluid bg-black">
        <div class="row pt-3 ps-5">
            <div class="col-2 text-start p-0 mt-1 mb-3">
                <localized-link to="/">
                    <img :src="`${publicPath}img/logoRocaGroup_${locale}.png`" width="160">
                </localized-link>
            </div>
        </div>
    </div>
    <div class="container-fluid p-0 m-0 bg-black">
        <div class="row g-0 p-0 mb-5">
            <div class="col-3 position-relative" id="colA">
                    <div class="welcomeBtnA text-start">
                        <h4 class="text-white ps-4 pb-4" v-html="$t('welcome.rocaGroup')"></h4>
                    </div>
                    <div id="layerA">
                        <p class="text-start"><localized-link class="ps-4" to="/roca-group-2022/presentacion">{{ $t("nav.presentacion") }}</localized-link></p>
                        <p class="text-start"><localized-link class="ps-4" to="/roca-group-2022/2022-en-resumen">{{ $t("nav.resumen") }}</localized-link></p>
                        <p class="text-start"><localized-link class="ps-4" to="/roca-group-2022/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link></p>
                    </div>
                    <img :src="`${publicPath}img/00rehomeA.jpg`" class="img-responsive">
            </div>
            <div class="col-3 position-relative" ID="colB">
                <div class="welcomeBtnB text-start">
                    <localized-link class="text-white" to="/avanzando-hacia-el-futuro"  data-target="/avanzando-hacia-el-futuro"><h4 class="text-white ps-4 pb-4" v-html="$t('welcome.avanzando')"></h4></localized-link>
                </div>
                <div id="layerB">
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></p>
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></p>
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></p>
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></p>
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></p>
                    <p class="text-start"><localized-link class="ps-4" to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></p>
                </div>
                 <img :src="`${publicPath}img/00rehomeB.jpg`" class="img-responsive">
            </div>
            <div class="col-3 position-relative" id="colC">
                <div class="welcomeBtnB text-start">
                    <localized-link class="text-white" to="/fundacion-we-are-water"  data-target="/fundacion-we-are-water"><h4 class="text-white ps-4 pb-4" v-html="$t('welcome.fundacion')"></h4></localized-link>
                </div>
                <div id="layerC">
                </div>
                <img :src="`${publicPath}img/00rehomeC.jpg`" class="img-responsive">
            </div>
            <div class="col-3 position-relative" id="colD">
                <div class="welcomeBtnD text-start">
                    <localized-link class="text-white" to="/informe-financiero"  data-target="/informe-financiero"><h4 class="text-white ps-4 pb-4" v-html="$t('welcome.informe')"></h4></localized-link>
                </div>
                <div id="layerD">
                </div>
                <img :src="`${publicPath}img/00rehomeD_${locale}.jpg`" class="img-responsive">
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                isEs:true,
                isEn: false,
                locale:this.$i18n.locale,
            }
        },
    };
</script>
